import { NoAddedCnt, TextCnt, MainText, SubText } from './noAddedRecords.style';
import { setDialog } from 'store/actions/dialogActions';
import { useDispatch } from 'react-redux';
import CustomButton from 'components/Button/CustomButton';

const NoAddedRecords = () => {
  const dispatch = useDispatch();

  return (
    <NoAddedCnt>
      <img src={'/assets/img/globe_location_empty_state.svg'} />{' '}
      <TextCnt>
        <MainText>
          Gain deeper insights and classify work orders with Locations
        </MainText>
        <SubText>
          Create and manage all the locations you will assign work orders and
          checklists to. Whether it's rooms in a building, areas in a facility
          or separate properties all together, Locations provides your team with
          the information they need.
        </SubText>
      </TextCnt>
      <CustomButton
        className="addBtn"
        variant="contained"
        onClick={() => {
          dispatch(
            setDialog({
              open: true,
              dialogId: 'createLocation',
            }),
          );
        }}
      >
        Add Location
      </CustomButton>
    </NoAddedCnt>
  );
};

export default NoAddedRecords;
